import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import PlantList from "./plant/PlantList";
import ProductionOrderList from "./production-order/ProductionOrderList";
import ProductionOrderForm from "./production-order/ProductionOrderForm";
import ProcessProductionOrderForm from "./production-order/ProcessProductionOrderForm";

export default function ProductionPage() {
  return (
    <Switch>
      <Redirect exact={true} from="/plant" to="/production/plants" />
      <Route path="/production/plants" component={PlantList} />
      <Route
        path="/production/production-order-list"
        component={ProductionOrderList}
      />
      <Route
        path="/production/production-order-form"
        component={ProductionOrderForm}
      />
      <Route
        path="/production/process-production-order-form/:productionOrderID"
        component={ProcessProductionOrderForm}
      />
    </Switch>
  );
}
